module.exports = __webpack_public_path__ + "img/1.6d26c40f.png";